import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalNotificationBanner, GlobalNotificationBannerService } from './global-notification-banner.service';

@Component({
  selector: 'td-wb-global-notification-banner',
  templateUrl: 'global-notification-banner.component.html',
  styleUrls: ['global-notification-banner.component.scss'],
  imports: [
    NgComponentOutlet
  ]
})
export class GlobalNotificationBannerComponent {
  private readonly globalNotificationBannerService = inject(GlobalNotificationBannerService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  banners: Array<GlobalNotificationBanner>;

  constructor() {
    this.globalNotificationBannerService.currentlyDisplayedBanners
      .pipe(takeUntilDestroyed())
      .subscribe((banners: Array<GlobalNotificationBanner>): void => {
        this.banners = banners;
        this.changeDetectorRef.markForCheck();
      });
  }
}
